var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ArrowBack, ArrowRight, InsertLinkOutlined } from "@mui/icons-material";
import { Stack, Typography, useMediaQuery } from "@mui/material";
import dayjs from "dayjs";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { CustomDownloadIcon, CustomPrintIcon, CustomShareIcon } from "../../jobCardDetails/assets/customIcons";
import { JciAccountPosting } from "../component/jciaccountingPosting";
import { JciReturnDisCard } from "../component/jciReturnDiscardPopup";
import { JCIReturnSavedSuccessfullyComponent } from "../component/jciReturnSaveSuccessFullPopup";
import { showSurface } from "../../../redux/awaitedSurfacesSlice";
import JciGeneralTabComponent from "../component/jciGeneralTabComponent";
import { JobCardInvoiceReturnInvoiceSummary } from "../component/JciReturnGrandAmount";
import ActionMenuList from "../../../builderPackage/components/actionsMenuList";
export var JciReturnUpdate = function (props) {
    var _getPurchaseOrderById;
    var navigate = useNavigate();
    var id = useParams().id;
    var dispatch = useAppDispatch();
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var getPurchaseOrderByIdData = useAppSelector(function (state) { return state.crud; }).getPurchaseOrderByIdData;
    var _b = useState(false), isDisCard = _b[0], setIsDisCard = _b[1];
    var _c = useState(false), isSave = _c[0], setIsSave = _c[1];
    var AdditionalInfo = [{
            type: FormItemTypes.CardComponent,
            name: 'AdditionalInfo',
            label: 'Notes & attachments',
            value: null,
            variant: 'outlined',
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    label: '',
                    value: null,
                    spacing: 2,
                    marginTop: 0,
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.TextInput,
                            name: 'Remarks',
                            label: 'Comment/notes (0/200 characters)',
                            placeholder: 'Enter comments...',
                            value: null,
                            multiline: true,
                            maxLength: 200,
                            minRows: 2,
                            columnSize: 6,
                            xs: 12,
                            sm: 6
                            // disabled: isDisabled ?? false,
                            // setFieldProps(formValues, value) {
                            //     return {
                            //         // type: this.type,
                            //         // label: `Comment/notes (${value?.length ?? 0}/200 characters)`
                            //     }
                            // },
                        }, {
                            type: FormItemTypes.Attachment,
                            name: 'Attachments',
                            label: 'Add attachments',
                            placeholder: 'Upload Files',
                            // disabled: isDisabled ?? false,
                            value: [],
                            inputProps: {
                                accept: 'application/*',
                                multiple: true
                            }
                            // uploadAttachmentRequest: { systemname: WorkPurchaseInvoiceKeys.AttachmentSystemName },
                            // uploadAttachmentAPI: uploadPurchaseInvoiceAttachment,
                            // deleteAttachmentAPI: purchaseInvoiceAttachmentDelete,
                        }]
                }]
        }];
    var AccountPosting = [{
            type: FormItemTypes.Custom,
            name: 'Posting details',
            label: '',
            value: null,
            element: JciAccountPosting,
            columnSize: 12
        }];
    var generalTab = [{
            type: FormItemTypes.Custom,
            name: 'Genaral details',
            label: '',
            value: null,
            element: JciGeneralTabComponent,
            columnSize: 12
        }];
    var tabs = [{
            id: "0",
            label: "General",
            elements: generalTab
        }, {
            id: "2",
            label: "Account posting",
            elements: AccountPosting
        }, {
            id: "3",
            label: "Additional info",
            elements: AdditionalInfo
        }];
    var disCardPopup = function (view) {
        setIsDisCard(false);
    };
    var clickOnQuickLink = function (e, formValue) { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(showSurface({
                        type: 'Menu',
                        Component: ActionMenuList,
                        containerProps: {
                            anchorEl: e === null || e === void 0 ? void 0 : e.target,
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left'
                            }
                        },
                        componentProps: {
                            items: [{
                                    id: 'JobCardInvoice',
                                    children: ["Job card invoice"]
                                }, {
                                    id: 'JobCard',
                                    children: ["Job card"]
                                }]
                        }
                    }))];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: "pageHeader",
            label: "",
            value: null,
            columnSize: 12,
            justifyContent: "space-between",
            alignItems: "center",
            spacing: 0,
            columnSpacing: 1,
            p: 2,
            elements: [{
                    type: FormItemTypes.IconButton,
                    name: "",
                    label: "",
                    value: null,
                    columnSize: 0,
                    children: /*#__PURE__*/ React.createElement(ArrowBack, {
                        fontSize: "small",
                        onClick: function () { return navigate("/jobCardInvoicesReturn"); }
                    })
                }, {
                    type: FormItemTypes.Typography,
                    name: "",
                    label: "",
                    value: null,
                    children: "New Job card invoice return",
                    columnSize: 0,
                    // variant: "h1",
                    fontSize: isMobile ? 'lg' : "xxl",
                    fontWeight: "strong",
                    noWrap: true
                }, {
                    type: FormItemTypes.Chip,
                    name: "",
                    label: "Open",
                    value: null,
                    columnSize: 0,
                    sx: {
                        color: '#3697FF'
                    }
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    label: "",
                    value: null,
                    columnSize: isMobile ? 12 : true,
                    item: false,
                    justifyContent: isMobile ? 'space-between' : "end",
                    spacing: 0,
                    elements: id ? [{
                            type: FormItemTypes.Typography,
                            name: "",
                            label: "DOC DATE:",
                            value: id ? dayjs(getPurchaseOrderByIdData === null || getPurchaseOrderByIdData === void 0 || (_getPurchaseOrderById = getPurchaseOrderByIdData.data) === null || _getPurchaseOrderById === void 0 ? void 0 : _getPurchaseOrderById.CreatedOn).format("DD MMM, YYYY") : null,
                            columnSize: 0,
                            // valueFormatter: (value: any) => dayjs(value).format('DD MMM, YYYY'),
                            labelTypographyProps: {
                                color: "text.tertiary",
                                fontSize: "sm",
                                fontWeight: "strong"
                            },
                            containerProps: {
                                display: "flex",
                                direction: "row",
                                alignItems: "center",
                                justifyContent: 'space-between',
                                spacing: 0,
                                gap: 1,
                                px: 1
                            }
                            // variant: "h6"
                        }] : []
                }, isMobile ? {
                    type: FormItemTypes.Divider,
                    name: "",
                    columnSize: 12
                } : null]
        }, !isMobile ? {
            type: FormItemTypes.ContainerItem,
            name: "actionPanel",
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "actionPanel",
                    columnSize: 0,
                    spacing: 0,
                    columnGap: 1.5,
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "",
                            label: "",
                            value: null,
                            children: "Quick Links",
                            columnSize: 0,
                            variant: "text",
                            startIcon: /*#__PURE__*/ React.createElement(InsertLinkOutlined, null),
                            onClick: clickOnQuickLink
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(CustomDownloadIcon, null),
                            columnSize: 0,
                            size: 'icon',
                            variant: "outlined",
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            label: "",
                            value: null,
                            children: /*#__PURE__*/ React.createElement(CustomShareIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            size: 'icon',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            label: "",
                            value: null,
                            children: /*#__PURE__*/ React.createElement(CustomPrintIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            size: 'icon',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Divider,
                            name: "",
                            columnSize: 0,
                            orientation: 'vertical',
                            sx: {
                                mx: 1
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: "draft",
                            label: "",
                            value: null,
                            children: "Discard",
                            columnSize: 0,
                            color: 'secondary',
                            // onClick: (e, formvalues) => {
                            //     setIsDisCard(true)
                            //     return "submit"
                            // },
                            onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                var res;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Dialog',
                                                Component: JciReturnDisCard,
                                                containerProps: {
                                                    PaperProps: {
                                                        sx: {
                                                            width: '400px',
                                                            height: 'auto',
                                                            borderRadius: '8px'
                                                        }
                                                    }
                                                }
                                            }))];
                                        case 1:
                                            res = _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); },
                            setFormState: function () { return ({
                                Status: "Draft"
                            }); }
                        }, {
                            type: FormItemTypes.Button,
                            name: "save",
                            label: "",
                            value: null,
                            id: 'save',
                            children: "Save",
                            columnSize: 0,
                            variant: "contained",
                            onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                var res;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Dialog',
                                                Component: JCIReturnSavedSuccessfullyComponent,
                                                containerProps: {
                                                    PaperProps: {
                                                        sx: {
                                                            width: {
                                                                xs: '328px',
                                                                sm: '400px'
                                                            },
                                                            height: 'auto',
                                                            borderRadius: '8px'
                                                        }
                                                    }
                                                }
                                            }))];
                                        case 1:
                                            res = _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); },
                            // onClick: (e, formvalues) => {
                            //     setIsSave(true)
                            //     return "submit"
                            // },
                            setFormState: function () { return ({
                                Status: "InProgress"
                            }); }
                        }],
                    justifyContent: "flex-end"
                }],
            spacing: 0,
            columnSpacing: 2,
            p: 2,
            justifyContent: "flex-end",
            bgcolor: 'secondary.100',
            borderBottom: "1px solid",
            borderTop: "1px solid",
            borderColor: 'secondary.200'
        } : null, {
            type: FormItemTypes.Tabs,
            name: "Stepper",
            label: "",
            value: null,
            tabs: tabs,
            valueExpr: "id",
            displayExpr: "label",
            columnSize: 12,
            tabProps: {
                sx: {
                    textTransform: "none"
                }
            }
        },
        //Total Amout PopUp
        {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            position: 'fixed',
            justifyContent: 'end',
            bottom: 0,
            right: 0,
            spacing: 0,
            p: '16px 24px 24px 24px!important',
            columnGap: 2,
            bgcolor: 'secondary.50',
            borderTop: '1px solid',
            borderColor: 'secondary.200',
            sx: {
                // paddingBottom: '10px',
                position: 'fixed',
                bottom: isMobile ? '0px' : '0px'
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    variant: 'outlined',
                    fullWidth: true,
                    color: 'secondary',
                    sx: {
                        bgcolor: 'white',
                        position: IS_DESKTOP ? 'relative' : '',
                        right: IS_DESKTOP ? '0px' : '2px'
                    },
                    xs: 12,
                    sm: 6,
                    md: 4,
                    lg: 4,
                    startIcon: /*#__PURE__*/ React.createElement(ArrowRight, {
                        height: 20,
                        width: 20
                    }),
                    setFieldProps: function (state) { return ({
                        type: FormItemTypes.Button,
                        children: /*#__PURE__*/ React.createElement(Stack, {
                            width: '100%',
                            justifyContent: 'space-between',
                            direction: 'row',
                            color: 'secondary.900'
                        }, /*#__PURE__*/ React.createElement(Typography, {
                            fontWeight: 'strong'
                        }, "Total amount"), /*#__PURE__*/ React.createElement(Typography, {
                            fontWeight: 'strong'
                        }, "\u20B9 ", state === null || state === void 0 ? void 0 : state.GrandTotal))
                    }); },
                    onClick: function (e) { return __awaiter(void 0, void 0, void 0, function () {
                        var res, _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    if (!isMobile) return [3 /*break*/, 2];
                                    return [4 /*yield*/, dispatch(showSurface({
                                            type: 'Drawer',
                                            Component: JobCardInvoiceReturnInvoiceSummary,
                                            containerProps: {
                                                anchor: 'bottom',
                                                PaperProps: {
                                                    sx: {
                                                        borderRadius: '8px 8px 0 0'
                                                    }
                                                }
                                            }
                                        }))];
                                case 1:
                                    _a = _b.sent();
                                    return [3 /*break*/, 4];
                                case 2: return [4 /*yield*/, dispatch(showSurface({
                                        type: 'Menu',
                                        Component: JobCardInvoiceReturnInvoiceSummary,
                                        containerProps: {
                                            anchorEl: e.currentTarget,
                                            sx: {
                                                '& .MuiPaper-root': {
                                                    borderRadius: '8px'
                                                }
                                            },
                                            anchorOrigin: {
                                                vertical: 'top',
                                                horizontal: 'center'
                                            },
                                            transformOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'center'
                                            }
                                        }
                                    }))];
                                case 3:
                                    _a = _b.sent();
                                    _b.label = 4;
                                case 4:
                                    res = _a;
                                    return [2 /*return*/];
                            }
                        });
                    }); }
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Stack, {
        sx: {
            bgcolor: 'secondary.50'
        }
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData
        // mode={id ? "edit" : "add"}
        ,
        formProps: {
            p: 2
        },
        onClose: function () { return navigate("/pdiCheck"); }
    })));
};
